<template>
<div class="chapter">
<div class="inner_page">
<table style="width:100%">
<tbody><tr>
<td style="width:20%"><p class="fm-04a">Central Index</p></td>
<td style="width:50%"><p class="fm-04a2">POLICE DEPARTMENT</p></td>
<td style="width:25%"><p class="fm-04a1">Form No. 272</p></td>
</tr>
<tr>
<td colspan="2"><p class="fm-04b">30/3B/112</p></td>
<td><p class="fm-04b1">File No.</p></td>
</tr>
<tr>
<td></td>
<td><p class="fm-04c">SERVING OFFICER’S RECORD CARD</p></td>
<td><p class="fm-04b1">372/1/6</p></td>
</tr>
<tr>
<td colspan="2"><p class="fm-04at">NAME: MILLER Nicholas Charles</p></td>
<td><p class="fm-04atr">NUMBER 982</p></td>
</tr>
</tbody></table>
<p class="fm-04k">ADDRESS: “Four Winds,” Fairview Avenue</p>
<p class="fm-04k">DATE OF BIRTH: 27th July, 1939</p>
<p class="fm-04k">AGE ON JOINING DEPARTMENT: 21</p>
<p class="fm-04k">OCCUPATION ON JOINING DEPARTMENT: Student</p>
<table>
<tbody><tr>
<td style="width:18%"><p class="fm-04b">EDUCATION:</p></td>
<td style="width:82%"><p class="fm-04bh">Foundation Scholar at Archbishop Holden’s Grammar School</p></td>
</tr>
<tr>
<td></td>
<td><p class="fm-04bh">Open Exhibition to London University 1956</p></td>
</tr>
<tr>
<td></td>
<td><p class="fm-04bh">London School of Economics</p></td></tr>
</tbody></table>
<p class="fm-07a">EDUCATIONAL ATTAINMENT: Bachelor of Law with Second Class Honours, University of London, 1959</p>
<p class="fm-04b">SERVICE RECORD: Joined Department, 1/2/60</p>
<p class="fm-08a">Passed out District Training centre, 1/5/60</p>
<p class="fm-08a">Certified as passing probationary year satisfactorily, 1/2/61</p>
<p class="fm-08a">Appointed to Central Division, 3/3/61</p>
<p class="fm-08a">Appointed Detective Constable and transferred to “E” Div. on 2/1/63 (See File National Bank Ltd., 21/12/62)</p>
<p class="fm-08a">Need to sit promotion exam waived by Watch Committee and put forward for place at Bramshill, 2/12/63 (See File Dale-Emmett Ltd., 3/10/63)</p>
<p class="fm-08a">Completed Special Course Bramshill with Distinction and promoted substantive Detective Sergeant, Central Division, effective 1/1/65</p>
<p class="fm-04b">COMMENDATIONS: 1/8/60 See File 2/B/321/Jones R.</p>
<p class="fm-09a">5/3/61 See File 2/C/143/Rogers R. T.</p>
<p class="fm-09a">4/10/61 See File 8/D/129/Messrs. Longley Ltd.</p>
<p class="fm-09a">5/6/62 See File 9/E/725/Ali Hamid</p>
<p class="fm-09a">21/12/62 See File 11/D/832/National Bank Ltd.</p>
<p class="fm-09a">3/10/63 See File 13/C/172/Dale-Emmett Ltd.</p>
<p class="fm-04b">CONFIDENTIAL ASSESSMENT: A highly intelligent officer with a genuine capacity for police work who possesses potential leadership qualities of a high order. Greatest fault, a tendency to work on his own. Tends to unorthodoxy in methods. It should be noted that this officer is a judo brown belt and an exponent of the art of karate, a Japanese mode of self-defence by which it is possible to kill an opponent with the bare hands. The undesirability of using such methods in the execution of his duty has been pointed out to this officer.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// frontmatter02.vue?e5c30144